import { apiClient } from '@utils';

export const useRetrieveCharts = () => {
  const result = apiClient.chart.retrieveCharts.useQuery(['retrieve-charts'], { params: { asAdmin: undefined } });
  return { ...result, data: result.data?.body?.data };
};
